import UserInstance from "./UserInstance";

const REALM = "navaantrix";
const CLIENT_NAME = "swagger";
const CLIENT_ID = "swagger";

//Use To featch users
export const fetchUsers = async () => {
  try {
    const response = await UserInstance.get(
      `/api/users/byRole/roleWise/${REALM}/${CLIENT_NAME}`
    );
    return response.data;
  } catch (error) {
    console.error("Fetch users failed:", error);
    throw error;
  }
};

//  Update user status
export const updateUserStatus = async (userId, updatedUser) => {
  try {
    const response = await UserInstance.put(
      `/api/users/${REALM}/${userId}`,
      updatedUser
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createUser = async (payload) => {
  return await UserInstance.post(`/api/users/${REALM}/${CLIENT_NAME}`, payload);
};

export const fetchUserById = async (userId) => {
  try {
    const response = await UserInstance.get(`/api/users/${REALM}/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Fetch user by ID failed:", error);
    throw error;
  }
};

export const updateUserById = async (userId, updatedUser) => {
  try {
    const response = await UserInstance.put(
      `/api/users/${REALM}/${userId}`,
      updatedUser
    );
    return response.data;
  } catch (error) {
    console.error("Update user failed:", error);
    throw error;
  }
};

export const deleteUserById = async (userId) => {
  try {
    const response = await UserInstance.delete(`/api/users/${REALM}/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Delete user failed:", error);
    throw error;
  }
};

// export const CreateUserFromAdmin = async (payload) => {
//   return await UserInstance.post(`/api/users/${REALM}/${CLIENT_NAME}`, payload);
// };

export const AssignRoleToUser = async (userId, role) => {
  return await UserInstance.post(
    `/api/users/realms/${REALM}/users/${userId}/clients/${CLIENT_NAME}`,
    role
  );
};

export const FetchRoles = async () => {
  return await UserInstance.get(
    `/api/realms/${REALM}/clients/${CLIENT_ID}/roles`
  );
};

// export const resetUserPassword = async (formData) => {

//   return await UserInstance.post(`/api/users/resetUserPassword`, formData);
// };

export const Getrole = async (userId) => {
  return await UserInstance.get(
    `/api/users/${REALM}/navaantrix/users${userId}/role-mappings`
  );
};


export const GetUserById = async (userId) => {
  return await UserInstance.get(
    `/api/users/${REALM}/${userId}`
  )
};


